import { ErrorHandler, Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppMonitoringService {
  appInsights: ApplicationInsights;


  filteringFunction = (envelope) => {
    // Do not log failed calls to get GetHWCDeviceInfo as there will be lots of these and it is normal.
    if (envelope.baseData.name.includes('GetHWCDeviceInfo'))
      return false;
    return true;
  }

  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: true, // option to log all route changes
        autoExceptionInstrumented: true,
        autoTrackPageVisitTime: true,
      }
    });
    this.appInsights.loadAppInsights();
    this.appInsights.addTelemetryInitializer(this.filteringFunction);
  }

  logPageView(name?: string, url?: string) { // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message }, properties);
  }
}

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

  constructor(private loggingService: AppMonitoringService) {
    super();
  }

  handleError(error: Error) {
    this.loggingService.logException(error); // Manually log exception
  }
}